export const auth = {
  login: {
    heading: '로그인',
    subtitle: 'EachTeach에 오신 것을 환영합니다',
    emailLabel: '이메일',
    emailPlaceholder: 'your@email.com',
    passwordLabel: '비밀번호',
    passwordPlaceholder: '비밀번호',
    forgotPassword: '비밀번호를 잊으셨나요?',
    invalidCredentials: '이메일 또는 비밀번호가 올바르지 않습니다',
    submitting: '로그인 중...',
    submit: '로그인',
    noAccount: '계정이 없으신가요?',
    register: '회원가입',
  },

  forgotPassword: {
    heading: '비밀번호를 잊으셨나요?',
    intro: '등록된 이메일 주소를 입력해 주세요. 비밀번호 재설정 링크를 보내드립니다.',
    sendError: '이메일 전송에 실패했습니다. 이메일 주소를 확인해 주세요.',
    sentTitle: '이메일을 전송했습니다',
    sentBody: '{{email}} 주소로 비밀번호 재설정 링크를 보냈습니다. 이메일을 확인해 주세요.',
    backToLogin: '로그인 화면으로 돌아가기',
    emailLabel: '이메일',
    emailPlaceholder: 'your@email.com',
    submitting: '전송 중...',
    submit: '재설정 링크 보내기',
  },

  resetPassword: {
    linkExpired: '재설정 링크의 유효 기간이 만료되었습니다. 다시 비밀번호 재설정을 요청해 주세요.',
    linkInvalid: '유효하지 않은 링크입니다. 다시 비밀번호 재설정을 요청해 주세요.',
    passwordMismatch: '비밀번호가 일치하지 않습니다',
    passwordMin: '비밀번호는 8자 이상으로 입력해 주세요',
    updateFailed: '비밀번호 업데이트에 실패했습니다. 다시 시도해 주세요.',
    linkErrorTitle: '링크가 유효하지 않습니다',
    requestAgain: '다시 재설정 요청',
    verifying: '인증 정보를 확인 중...',
    heading: '새 비밀번호 설정',
    subtitle: '8자 이상의 비밀번호를 입력해 주세요',
    successTitle: '비밀번호를 업데이트했습니다!',
    successBody: '로그인 화면으로 이동합니다...',
    newPasswordLabel: '새 비밀번호',
    newPasswordPlaceholder: '8자 이상',
    confirmLabel: '비밀번호(확인)',
    confirmPlaceholder: '다시 입력',
    submitting: '업데이트 중...',
    submit: '비밀번호 업데이트',
  },
};
